const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "utm_id",
];

/**
 * Añade los parámetros UTM de la URL actual a un enlace saliente
 * (por ejemplo, hacia iokus.co) sin sobreescribir los que ya traiga.
 */
export function withUtm(url: string): string {
  if (typeof window === "undefined") return url;
  try {
    const current = new URLSearchParams(window.location.search);
    const target = new URL(url);
    UTM_KEYS.forEach((key) => {
      const value = current.get(key);
      if (value && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
    return target.toString();
  } catch {
    return url;
  }
}